export default __webpack_public_path__ + "static/media/empty.89b93f00.svg";